import React from "react";
import { ShieldCheck, MapPin } from "lucide-react";

/**
 * Partnership trust strip — placed right after the hero so the visitor sees
 * the affiliation badges before any other content.
 */
export const PartnershipsBar = () => (
  <section
    data-testid="partnerships-bar"
    className="relative bg-[#0B1D44] border-y border-[#2F568F] py-5 md:py-6 overflow-hidden"
  >
    {/* Subtle diagonal pattern */}
    <div
      aria-hidden="true"
      className="absolute inset-0 opacity-[0.04] pointer-events-none"
      style={{
        backgroundImage:
          "repeating-linear-gradient(115deg, transparent 0 24px, #FFFFFF 24px 26px)",
      }}
    />

    <div className="relative w-full px-6 md:px-12 lg:px-20">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        {/* Trust headline */}
        <div className="flex items-start md:items-center gap-3 max-w-md">
          <ShieldCheck className="w-6 h-6 md:w-7 md:h-7 text-[#FF5A00] flex-shrink-0 mt-0.5 md:mt-0" />
          <div>
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#FF5A00] font-display font-bold mb-1">
              Oficina Certificada
            </div>
            <div className="font-display font-bold text-white text-base md:text-lg leading-tight">
              Parte de uma rede ibérica
              <br className="hidden md:block" /> com cobertura nacional.
            </div>
          </div>
        </div>

        {/* Partner badges */}
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 md:gap-4">
          <a
            href="https://www.confortauto.com/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="partner-confortauto"
            className="group flex items-center gap-3 px-4 py-3 bg-[#0E2452]/60 border border-[#2F568F] hover:border-[#FF5A00] transition-colors"
            title="Membro oficial da rede ConfortAuto"
          >
            <img
              src="/logo-confortauto.png"
              alt="ConfortAuto"
              className="h-9 md:h-10 object-contain flex-shrink-0"
            />
            <div className="min-w-0">
              <div className="text-[9px] uppercase tracking-[0.25em] text-[#A1A1AA] font-display">
                Membro oficial
              </div>
              <div className="font-display font-bold text-white text-sm leading-none mt-0.5 group-hover:text-[#FF5A00] transition-colors">
                ConfortAuto
              </div>
            </div>
          </a>

          <a
            href="https://www.hankooktire.com/eu/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="partner-hankook-masters"
            className="group flex items-center gap-3 px-4 py-3 bg-[#0E2452]/60 border border-[#2F568F] hover:border-[#FF5A00] transition-colors"
            title="Oficina Hankook Masters certificada"
          >
            <img
              src="/logo-hankook.png"
              alt="Hankook"
              className="h-7 md:h-8 object-contain flex-shrink-0"
            />
            <div className="min-w-0">
              <div className="text-[9px] uppercase tracking-[0.25em] text-[#A1A1AA] font-display">
                Oficina certificada
              </div>
              <div className="font-display font-bold text-white text-sm leading-none mt-0.5 group-hover:text-[#FF5A00] transition-colors">
                Hankook Masters
              </div>
            </div>
          </a>
        </div>

        {/* Coverage hint */}
        <div className="hidden lg:flex items-center gap-2 text-[#A1A1AA] font-body text-xs">
          <MapPin className="w-4 h-4 text-[#FF5A00]" />
          <span>
            +800 oficinas
            <br /> em Portugal e Espanha
          </span>
        </div>
      </div>
    </div>
  </section>
);

export default PartnershipsBar;
